export const benefits = [
  {
    title: "راه‌اندازی سریع و ساده",
    specialChar: "",
    desc: "کلاسترهای کوبرنتیز به سرعت و بدون نیاز به پیکربندی‌های پیچیده روی زیرساخت آماده بهره‌برداری می‌شوند، تا فرایند استقرار نرم‌افزارها تسهیل شود.",
  },
  {
    title: "مقیاس‌پذیری پویا و عملکرد پایدار",
    specialChar: "",
    desc: "امکان افزایش یا کاهش آنی منابع بر اساس تغییرات بار کاری، با حفظ ثبات و پایداری در شرایط مختلف، تضمین می‌کند که اپلیکیشن‌ها بدون اختلال اجرا شوند.",
  },
  {
    title: "امنیت مستمر و به‌روزرسانی‌های منظم",
    specialChar: "",
    desc: "با بهره‌گیری از مکانیزم‌های امنیتی پیشرفته و به‌روزرسانی‌های دوره‌ای کوبرنتیز آبالون، سلامت و حفاظت کلاسترها در برابر تهدیدات سایبری تضمین می‌شود.",
  },
  {
    title: "انعطاف‌پذیری استقرار",
    specialChar: "",
    desc: "سرویس کوبرنتیز مورد نیاز شما روی دیتاسنترهای آبالون یا زیرساخت‌های داخلی سازمان (On-Premise) با هر مدل معماری و مقیاسی پیاده‌سازی می‌شوند.",
  },
];

export const solutions = [
  {
    img: "backup.svg",
    name: "دسترس‌پذیری بالا و مکانیزم Self-healing",
    desc: "کانتینرها به صورت خودکار بین نودها جابه‌جا می‌شوند تا در شرایط کمبود منابع یا بروز خطا، اختلالی در عملکرد سرویس‌ها ایجاد نشود. همچنین کانتینرهای معیوب به سرعت حذف و جایگزین می‌شوند تا پایداری حفظ شود.",
    alt: "دسترس‌پذیری بالا و مکانیزم Self-healing",
    title: "دسترس‌پذیری بالا و مکانیزم Self-healing",
  },

  {
    img: "disaster.svg",
    name: "امنیت جداسازی‌شده اپلیکیشن‌ها",
    desc: "در سرویس کوبرنتیز مدیریت شده آبالون اپلیکیشن‌ها و وابستگی‌هایشان به صورت ایزوله اجرا شده و این جداسازی، ریسک تداخل یا نفوذ را کاهش و امنیت کلی محیط اجرایی را افزایش می‌دهد.",
    alt: "امنیت جداسازی‌شده اپلیکیشن‌ها",
    title: "امنیت جداسازی‌شده اپلیکیشن‌ها",
  },
  {
    img: "service.svg",
    name: "قابلیت جابه‌جایی بی‌وقفه بین زیرساخت‌ها",
    desc: "کانتینرها به سادگی و بدون نیاز به تغییر در کدهای اپلیکیشن، می‌توانند بین سرورها یا ارائه‌دهندگان ابری مختلف منتقل شوند. این امکان، از وابستگی به یک زیرساخت خاص جلوگیری می‌کند.",
    alt: "قابلیت جابه‌جایی بی‌وقفه بین زیرساخت‌ها",
    title: "قابلیت جابه‌جایی بی‌وقفه بین زیرساخت‌ها",
  },
  {
    img: "test.svg",
    name: "کارایی بالا و مصرف بهینه منابع",
    desc: "در کوبرنتیز مدیریت‌ شده آبالون، منابع پردازشی و حافظه به‌صورت اختصاصی در اختیار هر سازمان قرار می‌گیرد تا پایداری و کارایی سرویس‌ها تضمین شود. در صورت نیاز به افزایش یا کاهش ظرفیت، امکان تغییر سریع منابع فراهم است",
    alt: "کارایی بالا و مصرف بهینه منابع",
    title: "کارایی بالا و مصرف بهینه منابع",
  },
  {
    img: "startup.svg",
    name: "توزیع هوشمند بار کاری",
    desc: "کوبرنتیز مدیریت شده آبالون با استفاده از مکانیزم‌های لود بالانسینگ خودکار، بار کاری را به شکل متوازن بین کانتینرها توزیع می‌کند تا عملکرد بهینه و پایداری سیستم حتی در اوج فعالیت تضمین شود.",
    alt: "توزیع هوشمند بار کاری",
    title: "توزیع هوشمند بار کاری",
  },
];

export const managedKuber = [
  {
    img: "focus.svg",
    title: "امنیت پیشرفته",
    title_en: "",
    desc: "رمزنگاری داده‌ها و مانیتورینگ مداوم برای حفاظت کامل از کلاستر و اپلیکیشن‌ها",
  },
  {
    img: "devops.svg",
    title: "پشتیبانی از منابع متنوع",
    title_en: "",
    desc: "بهینه‌سازی استفاده از CPU ،GPU ،RAM و Storage برای بارهای کاری مختلف",
  },
  {
    img: "technical.svg",
    title: "ذخیره‌سازی پرسرعت",
    title_en: "",
    desc: "ارائه راهکارهای ذخیره‌سازی بلاک و آبجکت با کارایی بالا در کوبرنتیز مدیریت‌ شده آبالون",
  },
  {
    img: "monitoring.svg",
    title: "شبکه خصوصی ایزوله",
    title_en: "",
    desc: "اتصال امن کلاستر کوبرنتیز در دیتاسنتر آبالون به شبکه داخلی سازمان از طریق نورونتا",
  },
  {
    img: "exclusive.svg",
    title: "یکپارچگی با اکوسیستم آبالون",
    title_en: "",
    desc: "هماهنگی کامل با سرویس‌های ابری آبالون از جمله شبکه توزیع محتوا (CDN)، راهکارهای بکاپ و DR",
  },
  {
    img: "hardening.svg",
    title: "لودبالانسر پیشرفته",
    title_en: "",
    desc: "تنظیم هوشمند و خودکار منابع بر اساس بار کاری برای مصرف بهینه و عملکرد پایدار در کوبرنتیز آبالون",
  },
];

export const popularServices = [
  {
    title: "امنیت ابری",
    desc: "با استفاده از راهکارهای امنیتی پیشرفته مانند فضای کاری امن، فایروال ابری، WAF و سامانه (SIEM) از سرویس‌های سازمانی خود در فضای ابری محافظت کنید. ",
    logo: "CloudGuard-Service.svg",
    route: "/cloud-security",
  },
  {
    title: "خدمات دواپس آبالون",
    desc: "بدون نیاز به استخدام نیروی داخلی، متخصصان ابری آبالون به تیم فنی سازمان شما می‌پیوندند تا مسیر رشد را با شتاب و بدون دغدغه طی کنید.",
    logo: "VPS-Service.svg",
    route: "/devops",
  },
  {
    title: "دیتاسنتر ابری",
    desc: "دیتاسنتر ابری تمامی قابلیت‌های یک دیتاسنتر فیزیکی را روی ابر برایتان فراهم می‌کند و می‌تواند پاسخی برای پیچیده‌ترین و تخصصی‌ترین نیازهای ابری شما باشد. ",
    logo: "VPC-Service.svg",
    route: "/vpc",
  },
  {
    title: "شبکه توزیع محتوای CDN آبالون",
    desc: "با بیش از ۴۰ پاپ‌سایت فعال در ایران و ۵ قاره جهان، محتوای وب‌سایت و سرویس‌های آنلاین سازمان خود را با کمترین تأخیر، سریع‌تر و ایمن‌تر به کاربران برسانید. ",
    logo: "ManagedService-Service.svg",
    route: "/cdn",
  },
];

export const questions = [
  {
    title:
      "سرویس کوبرنتیز مدیریت‌شده آبالون چه مزایایی نسبت به راهکارهای سنتی زیرساختی دارد؟",
    answer:
      "کوبرنتیز مدیریت‌شده آبالون پیچیدگی‌های فنی در استقرار و مدیریت کلاسترها را حذف می‌کند و بستری پایدار و انعطاف‌پذیر برای اجرای اپلیکیشن‌های سازمانی فراهم می‌سازد. این سرویس با کاهش بار مدیریتی تیم‌های فنی، زمان و هزینه نگه‌داری زیرساخت را به حداقل می‌رساند.",
  },
  {
    title:
      "آیا می‌توان کلاسترهای کوبرنتیز را روی زیرساخت‌های داخلی سازمان (On-Premise) نیز اجرا کرد؟",
    answer:
      "بله. کوبرنتیز مدیریت‌شده آبالون هم روی دیتاسنترهای ابری آبالون و هم روی زیرساخت داخلی سازمان (On-Premise) قابل استقرار است. همچنین امکان پیاده‌سازی در مدل ابر ترکیبی (Hybrid Cloud) وجود دارد.",
  },
  {
    title:
      "چگونه امنیت داده‌ها و ارتباطات در کوبرنتیز مدیریت‌شده آبالون تضمین می‌شود؟",
    answer:
      "این سرویس با رمزنگاری داده‌ها، مانیتورینگ مداوم، به‌روزرسانی‌های امنیتی منظم و معماری مقاوم در برابر اختلال، امنیت و پایداری کلاسترها را تضمین می‌کند. علاوه بر این، کنترل دسترسی پیشرفته امکان مدیریت دقیق کاربران و سطح دسترسی آن‌ها را فراهم می‌کند.",
  },
  {
    title:
      "آیا سرویس کوبرنتیز آبالون از منابع سخت‌افزاری متنوع پشتیبانی می‌کند؟",
    answer:
      "بله. این سرویس امکان استفاده از منابع اختصاصی مانند CPU، RAM و فضای ذخیره‌سازی را متناسب با نیاز سازمان فراهم می‌کند. در صورت تغییر نیازمندی‌ها، منابع به‌سادگی و از طریق تیم پشتیبانی آبالون قابل افزایش یا کاهش هستند.",
  },
];
